import React from 'react';
import { LimitResource, LIMIT_RESOURCE_LABELS, PLAN_LIMITS, PlanId, normalizePlanForLimits, nextPlanFor } from '../lib/pricing';

const PLAN_NAMES: Record<PlanId, string> = {
  starter:      'Starter',
  professional: 'Professional',
  enterprise:   'Enterprise',
};

interface UpgradeLimitModalProps {
  resource:     LimitResource;
  currentUsage: number;
  plan:         string | null | undefined;
  onClose:      () => void;
}

export default function UpgradeLimitModal({ resource, currentUsage, plan, onClose }: UpgradeLimitModalProps) {
  const currentPlan = normalizePlanForLimits(plan);
  const limit       = PLAN_LIMITS[currentPlan][resource];
  const nextPlan    = nextPlanFor(currentPlan);
  const nextLimit   = nextPlan ? PLAN_LIMITS[nextPlan][resource] : null;
  const label       = LIMIT_RESOURCE_LABELS[resource];

  return (
    <div style={overlay} onClick={onClose}>
      <div style={card} onClick={(e) => e.stopPropagation()}>
        <button style={closeBtn} onClick={onClose} aria-label="Cerrar">✕</button>

        <div style={icon}>🔒</div>
        <h2 style={title}>Límite de {label} alcanzado</h2>
        <p style={subtitle}>
          Tu plan <strong style={{ color: '#cbd5e1' }}>{PLAN_NAMES[currentPlan]}</strong> permite hasta{' '}
          <strong style={{ color: '#cbd5e1' }}>{limit}</strong> {label}. Estás usando{' '}
          <strong style={{ color: '#f87171' }}>{currentUsage}/{limit}</strong>.
        </p>

        {nextPlan && (
          <div style={upgradeBox}>
            <p style={upgradeBoxLabel}>Con {PLAN_NAMES[nextPlan]} obtienes</p>
            <p style={upgradeBoxValue}>
              {nextLimit === null ? `${label} ilimitados` : `${nextLimit} ${label}`}
            </p>
          </div>
        )}

        <a href="/pricing" style={cta}>Ver planes →</a>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.65)',
  backdropFilter: 'blur(3px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 500,
  padding: '20px 16px',
};

const card: React.CSSProperties = {
  position: 'relative',
  background: '#1e293b',
  border: '1px solid #334155',
  borderRadius: 16,
  padding: '36px 32px 28px',
  width: '100%',
  maxWidth: 420,
  textAlign: 'center',
  boxShadow: '0 24px 48px rgba(0,0,0,0.5)',
};

const closeBtn: React.CSSProperties = {
  position: 'absolute',
  top: 14,
  right: 16,
  background: 'none',
  border: 'none',
  color: '#64748b',
  fontSize: '1.1rem',
  cursor: 'pointer',
  lineHeight: 1,
};

const icon: React.CSSProperties = {
  fontSize: '2.2rem',
  marginBottom: 10,
  lineHeight: 1,
};

const title: React.CSSProperties = {
  color: '#f1f5f9',
  fontSize: '1.15rem',
  fontWeight: 700,
  margin: '0 0 10px',
};

const subtitle: React.CSSProperties = {
  color: '#94a3b8',
  fontSize: '0.86rem',
  lineHeight: 1.65,
  margin: '0 0 18px',
};

const upgradeBox: React.CSSProperties = {
  background: 'rgba(47,191,113,0.08)',
  border: '1px solid rgba(47,191,113,0.25)',
  borderRadius: 10,
  padding: '12px 16px',
  marginBottom: 20,
};

const upgradeBoxLabel: React.CSSProperties = {
  color: '#2FBF71',
  fontSize: '0.72rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  margin: '0 0 2px',
};

const upgradeBoxValue: React.CSSProperties = {
  color: '#f1f5f9',
  fontSize: '1.1rem',
  fontWeight: 800,
  margin: 0,
};

const cta: React.CSSProperties = {
  display: 'block',
  padding: '12px',
  background: 'linear-gradient(135deg, #1D6FA3 0%, #2FBF71 100%)',
  color: '#fff',
  borderRadius: 10,
  fontWeight: 700,
  fontSize: '0.9rem',
  textDecoration: 'none',
};
